import React from "react";

import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  monthYearLabel: {
    "&&::first-letter": {
      textTransform: "capitalize",
    },
  },
}));
/**
 *
 * @param refMonth current month being displayed by the dashboard, runs 1-12
 * @param refYear current year being displayed by the dashboard
 * @returns "Month of YYYY"
 */
const MonthYearLabel = ({
  month,
  year,
  locale = "pt-BR",
  paragraph,
}: {
  month: string;
  year: string;
  locale?: string;
  paragraph?: boolean;
}) => {
  const { classes } = useStyles();

  const formatLocaleDate = () => {
    const refDate = new Date(+year, +month, 0);
    return refDate.toLocaleDateString(locale, {
      month: "long",
      year: "numeric",
    });
  };

  return (
    <Typography
      variant="h2"
      color="primary.dark"
      paragraph={paragraph && paragraph}
      className={classes.monthYearLabel}
    >
      {formatLocaleDate()}
    </Typography>
  );
};

export default MonthYearLabel;
